import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EcondosQuery } from '@api/model/query';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {
  private states = new Map<string, BehaviorSubject<EcondosQuery>>();

  getCurrentQuery(key: string) {
    if (!this.states.has(key)) {
      this.states.set(
        key,
        new BehaviorSubject<EcondosQuery>({
          $limit: 10,
          $page: 0
        })
      );
    }

    return this.states.get(key)!.value;
  }

  getState(key: string, defaultState: EcondosQuery | null = null): BehaviorSubject<EcondosQuery> {
    if (!this.states.has(key)) {
      this.states.set(
        key,
        new BehaviorSubject<EcondosQuery>({
          $limit: 10,
          $page: 0,
          ...defaultState
        })
      );
    }
    return this.states.get(key)!;
  }

  setState(key: string, query: EcondosQuery) {
    const currentQuery = this.getState(key)?.value;
    this.getState(key)?.next({ ...currentQuery, ...query });
  }

  clearState(key: string) {
    this.states.delete(key);
  }
}
